<template>
  <div class="activity-specific-info-card">
    <tabs
      :tabs="tabs"
      :active-tab="activeTab"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false"
      @startTabChange="activeTab = $event"
    />
    <div v-show="activeTab === 0" :style="{'height': '100%', 'padding-top': '17px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }">
      <management-map :style="{ 'height': 'calc(100% - 50px)'}" />
    </div>
    <div v-show="activeTab === 1" :style="{'height': '100%', 'overflow-y': 'auto', 'overflow-x': 'hidden' }">
      <fields-list
        :fields="activityObjectFields"
        :editing-data="false"
        :hide-lines="true"
      />
    </div>
  </div>
</template>

<script>
import ManagementMap from "@/newComponents/_Molecules/ManagementMap.vue";
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { bus } from '@/main.js';
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";

export default {
  name: "ActivitySpecificInfo",

  components: {
    ManagementMap,
    Tabs,
    FieldsList,
  },

  props: {
    activity: {
      type: Object,
    },
  },

  mixins: [activitiesTasksDataMixin],

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
    }
  },

  watch: {
    activity(value) {
      bus.$emit('draw-features', [value.object.geo_json])
    },

    activeTab(value) {
      if (value === 0) {
        bus.$emit('draw-features', [this.activity.object.geo_json]);
      }
    }
  },

  computed: {
    tabs() {
      return [
        { id: 'map', label: this.$i18n.tc("Map", 1) },
        { id: 'object', label: this.$i18n.tc("AssociatedObject", 1) },
      ]
    },

    activityObjectFields() {
      return this.activity && this.activity.object ? [
        {
          label: this.$i18n.tc("Label", 1),
          value: this.activity.object.label,
          varName: "object.label",
        },
        {
          label: this.$i18n.tc("Type", 1),
          value: this.getObjectTypeLabel(this.activity.object_type),
          varName: "object.type",
        },
      ] : []
    }
  }
}
</script>

<style scoped>
.activity-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  background-color: #fff;
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 72%;
}

.v-tabs >>> .v-tabs-bar {
  height: 39px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/TasksManagement/ActivitySpecificInfo.vue